import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.less']
})
export class PageNotFoundComponent {
  public constructor(private router: Router) {}

  public async goHome() {
    await this.router.navigate(['/']);
  }
}
